import React from 'react';
import { TipsMapType } from '..';

export const brandOverviewTips: TipsMapType = {
  en: (
    <>
      By Followers:
      <br />
      Combine and classify the list of influencers gathered from post statistics
      along with the list of streaming influencers from the Streamhatchet
      platform based on their follower counts.
      <br />
      <br />
      By Views:
      <br />
      Classify the list of influencers obtained from post statistics by view
      counts, excluding data related to streaming influencers.
      <br />
      <br />
      By Engagement:
      <br />
      Classify the list of influencers obtained from post statistics by
      engagement counts, excluding data related to streaming influencers.
    </>
  ),
  zh: (
    <>
      分粉丝数统计：
      <br />
      汇总舆情帖子统计出的网红表和Streamhatchet平台的直播网红表后，按粉丝量进行分类。
      <br />
      <br />
      分观看量统计：
      <br />
      汇总舆情帖子统计出的网红表后，按观看量进行分类。不包括直播网红数据。
      <br />
      <br />
      分互动量统计：
      <br />
      汇总舆情帖子统计出的网红表后，按互动量进行分类。不包括直播网红数据。
    </>
  ),
};
